<template>
  <v-container fluid text-xs-center>
    <v-layout>
      <v-flex xs12>
        <SourceTable />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import SourceTable from '@/components/companies/sources/SourceTable.vue'

export default {
  components: {
    SourceTable
  }
}
</script>
